export class Social{
    /**
     * Get a URL for a Facebook page
     * @param profileId User's Facebook ID
     * @returns URL to person's Facebook page
     */
    public static buildFacebookUrl = (profileId: string): string => `https://www.facebook.com/${profileId}`;

    /**
     * Get a URL for a user's Twitter profile
     * @param handle User's Twitter handle
     * @returns URL to person's Twitter profile
     */
    public static buildTwitterUrl = (handle: string): string => `https://www.twitter.com/${handle}`;

    /**
     * Get the URL for a user's LinkedIn profile
     * @param profileId User's LinkedIn profile ID
     * @returns URL to person's LinkedIn profile
     */
    public static buildLinkedinUrl = (profileId: string): string => `https://www.linkedin.com/in/${profileId}`;

    /**
     * Get the URL for an employee's photo
     * @param personalId Employee's personal ID
     * @returns URL of employee's photo
     */
    public static buildImageUrl = (personalId: number): string => `/images/agents/${personalId}.jpg`;
}